import { Command, EditorState, Transaction } from "prosemirror-state";
import { EditorView } from "prosemirror-view";

/**
 * Utility to mark PM commands to be "mutating".
 * The mutating commands is such a command that require to update toolbar after it finishes.
 */

/** To mark transaction as mutiting => toolbar must be updated */
export const MUTATING = "_mutating";

/**
 * Wraps a command to mark its transaction as "mutable".
 * @param command - The original ProseMirror command.
 * @returns A wrapped command that marks its transaction as mutable.
 */
export function mutating(command:Command):Command {
	return (state:EditorState, dispatch?: (tr: Transaction) => void, view?:EditorView) => {
		if (!dispatch) return command(state, null, view);

		return command(state, (tr) => {
			// Add metadata to mark this transaction as mutable
			tr.setMeta(MUTATING, true);
			dispatch(tr);
		}, view);
	};
}
